'use strict';

// core version + modules:
import Swiper, { Navigation, Scrollbar, A11y, Mousewheel } from 'swiper';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';

const SliderMulti = {
    els: null,
    init: function () {
        SliderMulti.els = document.querySelectorAll('.f-slider.multi--');
        if (SliderMulti.els && SliderMulti.els.length > 0) {
            SliderMulti.els.forEach((el, index) => {
                try {
                    SliderMulti.create(el);
                } catch (error) {
                    console.error('slider error', index, error);
                }
            });
        }
    },
    create: function (el) {
        const slider = el.querySelector('.swiper');

        slider.swiper = null;

        let modules = '';
        let navigation = null;
        let scrollbar = null;

        if (slider.dataset.navigation === 'arrows') {
            const slideCount = slider.querySelectorAll('.swiper-slide').length;
            const toggleMousewheel = (swiper) => {
                const shouldEnable = window.innerWidth < 1050 || slideCount > 3;

                shouldEnable
                    ? swiper.mousewheel.enable()
                    : swiper.mousewheel.disable();
            };

            slider.swiper = new Swiper(slider, {
                roundLengths: true,
                modules: [Navigation, Mousewheel, A11y],
                a11y: true,
                spaceBetween: 16,
                slidesPerView: 'auto',
                loop: false,
                speed: 600,
                autoHeight: false,
                mousewheel: {
                    forceToAxis: true,
                    releaseOnEdges: true,
                },
                navigation: {
                    prevEl: '.f-slider__navigation-prev',
                    nextEl: '.f-slider__navigation-next',
                },
                breakpoints: {
                    841: {
                        spaceBetween: 24,
                    },
                    1050: {
                        allowTouchMove: slideCount > 3,
                        spaceBetween: 32,
                    },
                    1320: {
                        allowTouchMove: slideCount > 3,
                        spaceBetween: 32,
                    },
                }, //swiper-button-disabled
                on: {
                    init: function () {
                        toggleMousewheel(this);

                        if (this.slides.length <= 3) {
                            slider.classList.add('threeorless');
                        } else {
                            slider.classList.remove('threeorless');
                        }

                        if (
                            !this.navigation?.nextEl ||
                            !this.navigation?.prevEl
                        ) {
                            return;
                        }

                        if (
                            this.navigation.nextEl.classList.contains(
                                'swiper-button-disabled',
                            ) &&
                            this.navigation.prevEl.classList.contains(
                                'swiper-button-disabled',
                            )
                        ) {
                            this.navigation.nextEl.style.visibility = 'hidden';
                            this.navigation.prevEl.style.visibility = 'hidden';
                        } else {
                            this.navigation.nextEl.style.visibility = 'visible';
                            this.navigation.prevEl.style.visibility = 'visible';
                        }
                    },
                    resize: function () {
                        if (
                            !this.navigation?.nextEl ||
                            !this.navigation?.prevEl
                        ) {
                            return;
                        }

                        if (
                            this.navigation.nextEl.classList.contains(
                                'swiper-button-disabled',
                            ) &&
                            this.navigation.prevEl.classList.contains(
                                'swiper-button-disabled',
                            )
                        ) {
                            this.navigation.nextEl.style.visibility = 'hidden';
                            this.navigation.prevEl.style.visibility = 'hidden';
                        } else {
                            this.navigation.nextEl.style.visibility = 'visible';
                            this.navigation.prevEl.style.visibility = 'visible';
                        }
                    },
                    breakpoint() {
                        toggleMousewheel(this);
                    },
                },
            });
        }
        if (slider.dataset.navigation === 'scrollbar') {
            slider.swiper = new Swiper(slider, {
                roundLengths: true,
                modules: [Scrollbar, A11y],
                a11y: true,
                spaceBetween: 16,
                slidesPerView: 'auto',
                loop: false,
                speed: 600,
                autoHeight: false,
                scrollbar: {
                    el: '.f-slider__scrollbar',
                    hide: false,
                    draggable: true,
                },
            });
        }
    },
};

export default SliderMulti;
